const sendMessage = message => {
  console.log('🔵 You sent: ' + message);
};

export { sendMessage };
